import { Component, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base.component';
import { TranslationService } from 'src/app/services/utilities/translation.service';
import { PostService } from 'src/app/services/repositories/post.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';
import { SocialMediaAPIService } from 'src/app/services/utilities/socialMediaApi.service';
import { ICON } from 'src/app/interfaces/ModalIcon';
import { Debug } from 'src/app/utils/debug';
import { AuthService } from 'src/app/services/utilities/auth.service';
import { WebSocketService } from 'src/app/services/utilities/websocket.service';
import { Subject ,Subscription} from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UniqueSelectionDispatcher } from '@angular/cdk/collections';

@Component({
  selector: 'app-posts-library',
  templateUrl: './posts-library.component.html',
  styleUrls: ['./posts-library.component.scss'],
})
export class PostsLibraryComponent extends BaseComponent {
  @Input() dashboard: boolean = false;
  @Input() dashboardSource: string | null = null;
  @Input() dateRange:any={}

  windowWidth: number = window.innerWidth;
  isLargeView: boolean = false;
  isMediumView: boolean = false;
  isSmallView: boolean = false;
  isVerySmallView: boolean = false;
  currentDateTime: string;

    @ViewChild('postContainer') postContainer!: ElementRef;

  constructor(
    translationService: TranslationService,
    protected postService: PostService,
    protected uiStateService: UiStateService,
    private socialMediaApiService: SocialMediaAPIService,
    protected authService: AuthService,
    private webSocketService: WebSocketService,
        private route: ActivatedRoute
  ) {
    super(translationService);
    this.currentDateTime = new Date().toString();
    this.checkWindowSize();
  }
  posts: any = [];
  plannedPosts: any = [];

  @Input() currentPlaTformsFilters: any = { // delete Input
    isFacebookON: false,
    isLinkedinON: false,
    isGoogleON: false,
    isInstagramON: false,
  };

  @Input()currentPostsTypeFilter:any={
    isPlanned:false,
    isPosted:false,
    isDraft:false,

  }

  isLoading: boolean = true;
  doneLoadingPosts: boolean = false;
  previousScrollPosition = 0;

  isPublished: boolean = true;
  groupScopes: number[] = [];

  user!: any;
  navigation: any = {
    itemsPerPage: 20,
    page: 0,
  };
  subscriptions: Subscription[] = [];
    private deletionJobCounts = new Map<number, number>(); // keep track of which post was deleted and how many times (i.e. on how many pages)
  platformsSubscription!:Subscription
  typesSubscription!:Subscription
  dateRangeSubscription!:Subscription
  isRouteOnDashboard(){
    return(document.location.href.split('/').includes('dashboard'))
  }

  dashboardPlatform(){
    if(this.dashboardSource){
      return document.location.href.split('/')[document.location.href.split('/').length-1]
    }
    return false
  }
  removePost(id:any){
    //console.log("[posts-library] removing",id,"...")
    this.posts = this.posts.filter((p:any)=>p.id!=id)
  }

  private filterUpdate$ = new Subject<string>();
  isDeleteDisabled:boolean=false
  ngOnInit(): void {
    this.dateRange = this.dashboard?this.uiStateService.dateRangeUpdateSubject.getValue():this.dateRange
    if(this.dashboard){
      // console.log(this.currentPostsTypeFilter)
      this.uiStateService.postTypesUpdated.next({...this.currentPostsTypeFilter,isFailed:false})
    }
    this.user = this.authService.loadUserfromLs();
   this.currentPostsTypeFilter = this.isRouteOnDashboard()?{isPosted:this.currentPostsTypeFilter.isPosted,isPlanned:this.currentPostsTypeFilter.isPlanned}:this.uiStateService.postTypes;
    // Debounce and call getPosts
    this.subscriptions.push(this.filterUpdate$.pipe(debounceTime(300)).subscribe((reason) => {
      this.navigation.offset = 0;
      this.posts = [];
      this.getPosts(reason);
    }));

    this.subscriptions.push( this.postService.currentGroups.subscribe((groups) => {
      this.groupScopes = groups;
      this.uiStateService.updateGroupScopes(groups)
      this.triggerPostUpdate("group scopes");
    }));

    if (!this.isRouteOnDashboard()) {
      this.subscriptions.push(this.uiStateService.platformsFilterUpdated$.subscribe((data) => {
        this.currentPlaTformsFilters = data;
        this.triggerPostUpdate("platforms");
      }));

      this.subscriptions.push(this.uiStateService.dateRangeUpdate$.subscribe((data) => {
        this.dateRange = data;
        // console.log("dateRange changed in library",this.dateRange)
        this.triggerPostUpdate("dateRange");
      }));

    }

    this.subscriptions.push(this.uiStateService.dateRangeUpdate$.subscribe((data) => {
      this.dateRange = data;
      // console.log('🔵[posts-library] new dateRange:', data);
      this.triggerPostUpdate("dateRange");
    }));

    this.subscriptions.push(this.uiStateService.pageStatsdateRangeUpdate$.subscribe((data) => {
      this.dateRange = data;
      //  console.log('[posts-library] new pageStatsdateRangeUpdate:', data);
      this.triggerPostUpdate("dateRange");
    }));

    this.subscriptions.push(this.uiStateService.postTypesUpdated$.subscribe((data) => {
      this.currentPostsTypeFilter = data;
      this.triggerPostUpdate("post type");
    }))
    // get this month posts
        //Listend To post events via Websocket (deletion, creation started and creation completed)
        this.setupWebSocketListeners()
  }

  getElementWidth() {
    return this.postContainer?.nativeElement
  }
    private setupWebSocketListeners(): void {
        const events = [
            'postCreationCompleted',
            'postCreationStarted',
            'postDeletionStarted',
            'postDeletionCompleted',
            'postUpdateStarted',
            'postUpdateCompleted',
            'postUpdateFailure'
        ];

        events.forEach((eventType) => {
            this.webSocketService.listen(eventType, (data: any) => {

                this.handlePostEvent(eventType, data);
            });
        });
    }

    // Function to trigger updates
  private triggerPostUpdate(reason: string): void {
    this.filterUpdate$.next(reason);
  }
  override ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  private handlePostEvent(eventType: string, data: any): void {
        // console.log(`🔻${eventType}:`, data);
    const { post } = data;
    const postId = parseInt(post.id);
    //check if we are in the correct context
    if (eventType === 'postDeletionCompleted') {
      const { fullyDeleted } = data;

      // Handle deletion-specific logic
      const remainingJobs = (this.deletionJobCounts.get(postId) || 0) - 1;
      // console.log('[posts-library] remainingJobs', remainingJobs);

      if (remainingJobs <= 0) {
        // Remove the element if remainingJobs is 0 or less
        this.deletionJobCounts.delete(postId);
        post.status = null;
      } else {
        // Otherwise, update the count
        this.deletionJobCounts.set(postId, remainingJobs);
      }

      // If fully deleted, remove the post from the list
      if (fullyDeleted) {
        this.posts = this.posts.filter((p: any) => p.id !== postId);
        return;
      }
    }

    if(eventType === 'postCreationCompleted') {
      // this.inprogressPost = null;
      this.posts.forEach((p:any)=>{if(p.id===p.id){
        p.status=null
      }})
    }

    const postIndex = this.posts.findIndex((p: any) => p.id === postId);

    if (postIndex !== -1) {
      // Update or replace the post in the list
      this.posts[postIndex] = post;
    }
  }


  activePlatforms: string[] = [];
  SetActivePlatforms(platformList:any) {
    const result:any = [];
    for (let platform in platformList) {
      if (platformList[platform]) {
        // console.log(platform.substring(2,platform.length-2).toLowerCase());
        result.push(
          platform.substring(2, platform.length - 2).toLowerCase()
        );
      }
    }
    return result
  }
  activePostTypes:string[]=[]
  SetActivePostTypes(postTypes:any){
  const results=[]
    for (let postType in postTypes){
      if(postTypes[postType as keyof typeof this.uiStateService.postTypes]){

        if(postType=="isDraft" && !this.isRouteOnDashboard()){
          results.push("draft")
        }
        if(postType=="isPlanned"){
          results.push("planned")
        }
        if(postType=="isPosted"){
          results.push("published")
        }
        if(postType=="isFailed" && !this.isRouteOnDashboard()){
          results.push("failed")
        }
      }
    }
    return results
  }
  loadingMessage: string = 'posts.loadingPosts';
  infinitScroll(event: any) {
    const element = event.target;
    const isScrollingDown = element.scrollTop > this.previousScrollPosition;
    const isBottomReached =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 10;

    if (isScrollingDown && isBottomReached) {
      if (this.doneLoadingPosts && !this.isLoading) {
        this.isLoading = true;
        this.getPosts("scroll"); // Load more posts
        // console.log("You've reached the end of this chunk");
      }
    }

    // Update the previous scroll position
    this.previousScrollPosition = element.scrollTop;
  }

  noPostsMsg:string=""
  getPosts(label:string): void {

    console.log(`[posts-library] getPosts called due to: ${label} context :${this.isRouteOnDashboard()?"dashboard":"library"}`,);
    const lsData = this.postService.getGroupScopesFromLocalStorage();
    // console.log("getposts called for:",label,"context",this.groupScopes,)
    this.groupScopes = lsData.length > 0 ? lsData : this.groupScopes;
    this.activePlatforms=[]
    // console.log({...this.currentPlaTformsFilters})
    // console.log({...this.currentPostsTypeFilter})

    this.activePlatforms = [...this.SetActivePlatforms({...this.currentPlaTformsFilters})];
    this.activePostTypes = [...this.SetActivePostTypes({...this.currentPostsTypeFilter})];

    // console.log('getPost platforms',this.activePlatforms,"types",this.activePostTypes,"dateRange",this.dateRange);
    if(this.activePlatforms.length ==0 || this.activePostTypes.length==0) {
      this.posts = []
      this.noPostsMsg = 'noPosts'
      this.doneLoadingPosts = true;
      this.chekcloading();
      return
    }

    if (this.groupScopes.length > 0) {

      if (this.dateRange) {
            // console.log(`[posts-library]`,this.dateRange,this.dashboardSource,this.dashboard,this.isRouteOnDashboard())
        this.doneLoadingPosts = false;
        this.isLoading = true;
        this.dateRange.startDate??= new Date(new Date().getFullYear() - 2, 0, 1 )
        if(typeof this.dateRange.startDate === 'string' && typeof this.dateRange.endDate=== 'string'){
          this.dateRange.startDate = new Date(this.dateRange.startDate)
          this.dateRange.endDate = new Date(this.dateRange.endDate)
        }
        // this.dateRange.endDate??= new Date(new Date().getFullYear(), 11, 31)
        // console.log("-------------(loading posts)----------------")
        // console.log("loading postst of:");
        // console.log(" range ",JSON.stringify(this.dateRange))
        // console.log(" types ",JSON.stringify(this.activePostTypes))
        // console.log(" platforms ",JSON.stringify(this.activePlatforms))
        if(this.activePlatforms.length > 0) {
          this.dateRange.startDate.setHours(0, 0, 0, 0);
          console.log(`[posts-library] fetching posts with navigation`, this.dateRange.endDate);
          this.postService
          .getByDateRange(
            this.dateRange.startDate,
            this.dateRange.endDate,
            this.groupScopes,
            this.activePlatforms,
            this.activePostTypes,
            this.navigation.limit,
            this.navigation.offset,
          )
          .subscribe((res) => {
            if(res.data.length>0){

              // remove duplicates as temp fix for overlapping requests
                const newPosts = res.data.filter((post: any) => {
                return !this.posts.some((existingPost: any) => existingPost.id === post.id);
              });
              // Append only the new, unique posts
              this.posts = [...this.posts, ...newPosts];
              //const postTxts = [...new Set(this.posts.map((p:any)=>JSON.stringify(p)))]
              //this.posts = postTxts.map((p:any)=>JSON.parse(p))
              // const tmpPost =localStorage.getItem('tmp_post' );
              // if(tmpPost!=null){
              //   this.inprogressPost = JSON.parse(tmpPost);
              //   // console.log("👉👉👉inprogressPost",this.inprogressPost)
              //   const postIds = this.posts.map((p:any)=>p.id)
              //   if( !postIds.includes(this.inprogressPost.id)){
              //     this.posts=[this.inprogressPost,...this.posts]
              //   }
              //   // remove tmp post from local storage
              //   localStorage.removeItem('tmp_post');
              // }

              this.navigation = res.navigation;
              this.navigation.limit = Number(this.navigation.limit);
              this.navigation.offset = Number(this.navigation.offset);
              if (res.data.length > 0) {
                this.navigation.offset += this.navigation.limit;
              }
              // console.log('new navigation', this.navigation);
            }
            else{
              console.log("no posts received due to",res)
              this.noPostsMsg = res.data.msg
            }
            this.doneLoadingPosts = true;
            this.chekcloading();
          });
        }
      }
    }
  }
  doneLoadingDrafts = false;
  chekcloading() {
    if (this.doneLoadingPosts) {
      this.isLoading = false;
    } else {
      this.isLoading = true;
    }
  }
resetFilters(){
    console.log("resetFilters to defaults")
    this.uiStateService.updatePlatformsFilter({
      isFacebookON: true,
      isLinkedinON: true,
      isGoogleON: true,
      isInstagramON: true,
    })
    this.uiStateService.updatePostTypeFilter({
      isPlanned:true,
      isPosted:true,
      isDraft:true,
      isFailed:false
    })
    this.uiStateService.updateDateRange({
      startDate: new Date(new Date().getFullYear() - 2, 0, 1 ),
      endDate: new Date(new Date().getFullYear(), 11, 31)
    })
}

openPostFactory(){
  document.location.href="/posts"
}
  //modal data
  modalIcon = ICON.delete;
  modalHeading = '';
  modalSubHeading = '';
    modalIsEdit = false

  currentPost: any = null;

    openDeleteModal(post: any, action: any) {
        if (action == 'update') {
            // console.log("[posts-library] action", action)
            this.modalIcon = ICON.edit;
            this.modalIsEdit = true
            this.modalHeading = 'posts.editInstagram';
            this.modalSubHeading = '';
        }
    else if (action == 'cancel') {
            // console.log("[posts-library] action", action,post)
            this.modalIcon = ICON.delete;
            this.modalHeading = 'generic.confirmCancelPublication';
            this.modalSubHeading = 'generic.confirmCancelPublicationMsg';
        }
    else {
      // console.log("[posts-library] should not use this case", action)
            this.modalIcon = ICON.delete;
            this.modalHeading = 'generic.confirmDeletion';
            this.modalSubHeading = 'generic.confirmPostDeletionMsgs';
        }
        this.confirmDeleteModalVisible = true;
        this.currentPost = post
    }

  confirmPostRemoval(event: any) {
      // Call the delete function
      this.isDeleteDisabled=true
      this.deletePost(this.currentPost, event?.selected || null);
      console.log("del confirmed",this.isDeleteDisabled)
  }

  confirmDeleteModalVisible: boolean = false;

  deletePost(post: any, selectedSocialMediasIds: any[] | null) {
    // Initialize the job count for the post
    if (selectedSocialMediasIds) {
      this.deletionJobCounts.set(post.id, selectedSocialMediasIds.length);
    }

    this.postService.deletePost(post, selectedSocialMediasIds).subscribe((res) => {
      if (res.success) {
        console.log("deleting posts ",post.id,"selectedSocialMediasIds",selectedSocialMediasIds)
        if (selectedSocialMediasIds && selectedSocialMediasIds.length > 0) {
        const refreshedSocialMedias = post.SocialPlatforms.filter((p: any) => !selectedSocialMediasIds.includes(p.id));

        if (refreshedSocialMedias.length > 0) {
          // Create a new post object to change the reference
          const updatedPost = { ...post, SocialPlatforms: refreshedSocialMedias };

          // Find and replace in this.posts
          const postIndex = this.posts.findIndex((p: any) => p.id === post.id);
          if (postIndex !== -1) {
            this.posts[postIndex] = updatedPost;
            // No need for refreshPost() anymore, as the replacement triggers change detection
          }
        } else {
          this.posts = this.posts.filter((po: any) => po.id !== post.id);
        }
      }
        //change modal icon and heading and hide them after 1.5 s
        this.modalIcon = ICON.success;
        this.modalHeading = 'generic.successDeletePost';
        this.modalSubHeading = 'generic.mayTakeMinutes';
          if (res.data.draft) { // if draft, remove from the page
              const postIndex = this.posts.findIndex((p: any) => p.id === post.id);
              if (postIndex !== -1)
                  this.posts.splice(postIndex, 1);
          }
          setTimeout(() => {
            this.confirmDeleteModalVisible = false;
            //  reset them back for the next post deletion"
            this.modalIcon = ICON.delete;
            this.modalHeading = 'generic.confirmDeletion';
            this.modalSubHeading = 'generic.confirmPostDeletionMsg';
          }, 1500);
        }
        this.isDeleteDisabled=false
      });

  }
  refreshPost(post:any){
    console.log("refreshing post",post)
    for (const p of this.posts) {
      if (p.id === post.id) {
        console.log("found old ",p.SocialPlatforms,"replacing it with ",post.SocialPlatforms)
        //Object.assign(p, post);
        break;
      }
    }

    const UniQuePlatforms = [...new Set(post.SocialPlatforms.map((s:any)=>s.source))]
    console.log("new post platforms",UniQuePlatforms)
  }
  isDataEmpty(){

   return !this.isFiltersEmpty()
  }
  isFiltersEmpty(){
    return this.activePlatforms.length==0 || this.activePostTypes.length==0
  }

  isDeletionInProgress(postId: number): boolean {
      return (this.deletionJobCounts.get(postId) || 0) > 0;
  }

  togglePost() {
    this.currentPostsTypeFilter.isPosted = !this.currentPostsTypeFilter.isPosted
  }

  toggleDraft() {
    this.currentPostsTypeFilter.isDraft = !this.currentPostsTypeFilter.isDraft
  }

  togglePlanned() {
    this.currentPostsTypeFilter.isPlanned = !this.currentPostsTypeFilter;
  }

  checkVisibility(post:any){
    //check if post platforms on the filter
    const postUniquePlatforms = ([...new Set(post.SocialPlatforms.map((sm:any) => sm.source ))]) as string[]
    // console.log("postUniquePlatforms",postUniquePlatforms)
    if(this.displayAs(post) == "failed" && this.uiStateService.postTypesUpdated.getValue().isFailed || this.displayAs(post) == "unattached"){
        return true
    }
    if(postUniquePlatforms.length==0)return false
    //get display as
    if(new Date(post.expectedPublishingDatetime) > new Date()){
        return this.currentPostsTypeFilter.isPlanned
    }
    if(this.displayAs(post)==="draft" && post.publishingDatetime == null && post.expectedPublishingDatetime==null){
      return this.currentPostsTypeFilter.isDraft
    }
    if(this.displayAs(post)!=='failed'){

      if (post.publishingDatetime &&  new Date(post.publishingDatetime) < new Date())
        {
          return this.currentPostsTypeFilter.isPosted
      }
      if (post.expectedPublishingDatetime && new Date(post.expectedPublishingDatetime) < new Date())
        {
          return this.currentPostsTypeFilter.isPosted
        }
    }
    //compare display as
    return false
  }

  sortPosts(posts: any[]): any[] {
    posts.sort((a: any, b: any) => {
      const dateA = new Date(a.publishingDatetime || a.expectedPublishingDatetime || a.createdAt).getTime();
      const dateB = new Date(b.publishingDatetime || b.expectedPublishingDatetime || b.createdAt).getTime();

      return dateB - dateA;
    });

    return posts;
  }

  private checkWindowSize() {
    this.windowWidth = window.innerWidth;
  }

  userHasPermission(permission: string): boolean {
    return (
      this.user?.isAdmin ||
      this.user?.accreditations[0]?.profile?.permissions.some((profilePermission: any) => profilePermission.action == permission)
    )
  }

  isFetchingForFacebookPosts: boolean = false;
  isFetchingForInstagramPosts: boolean = false;
  fetchPosts(source: string) {
    switch (source) {
      // case 'linkedin':
      //   this.isFetchingForLinkedinPosts = true;
      //   this.linkedinFetchData.show = false;
      //   break;
      // case 'google':
      //   this.isFetchingForGooglePosts = true;
      //   break;
      case 'facebook':
        this.isFetchingForFacebookPosts = true;
        break;
      case 'instagram':
        this.isFetchingForInstagramPosts = true;
        break;
    }

    const pagesIds = this.user.accreditations[0].group.socialMedia
      .filter(
        (sm: any) => sm.source.toLowerCase() == source.toLocaleLowerCase()
      )
      .map((socialMedia: any) => socialMedia.id);

      // console.log("pagesIds", pagesIds)
    this.socialMediaApiService.fetchPagePosts(pagesIds).subscribe((res) => {
      const syncData = res.data.data[0].fetchingResults;

      switch (source) {
        // case 'linkedin':
        //   this.linkedinFetchData.show = true;
        //   this.linkedinPostsCount =
        //     syncData.updatedPosts + syncData.insertedPost;
        //   this.linkedinFetchData.fetched =
        //     syncData.updatedPosts + syncData.insertedPosts;
        //   this.linkedinFetchData.added = syncData.insertedPosts;
        //   this.linkedinFetchData.updated = syncData.updatedPosts;
        //   this.isFetchingForLinkedinPosts = false;
        //   break;
        // case 'google':
        //   this.googleFetchData.show = true;
        //   this.googleFetchData.fetched =
        //     syncData.updatedPosts + syncData.insertedPosts;
        //   this.googleFetchData.added = syncData.insertedPosts;
        //   this.googleFetchData.updated = syncData.updatedPosts;
        //   this.isFetchingForGooglePosts = false;
        //   break;

        case 'facebook':
          // this.facebookFetchData.show = true;
          // this.facebookFetchData.fetched =
          //   syncData.updatedPosts + syncData.insertedPosts;
          // this.facebookFetchData.added = syncData.insertedPosts;
          // this.facebookFetchData.updated = syncData.updatedPosts;
          this.isFetchingForFacebookPosts = false;
          // console.log('res.data.data FB', res.data.data)
          window.location.reload();
          break;
        case 'instagram':
          // this.instagramFetchData.show = true;
          // this.instagramFetchData.fetched =
          //   syncData.updatedPosts + syncData.insertedPosts;
          // this.instagramFetchData.added = syncData.insertedPosts;
          // this.instagramFetchData.updated = syncData.updatedPosts;
          this.isFetchingForInstagramPosts = false;
          // console.log('res.data.data insta', res.data.data)
          window.location.reload();
          break;
      }
    });
  }


    handleDuplicatePost(event: any) {

        const newPost = event.data

        // Add the post at the top and mark it as new
    newPost.isNew = true;
    this.posts = [newPost, ...this.posts];

    // Scroll back to top
    setTimeout(() => {
            this.postContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);

    // Remove the 'isNew' flag after animation
    setTimeout(() => {
      newPost.isNew = false;
    }, 4000);
    }

  displayAs(post: any): string {

      if (post) {
        if (post.publishingDatetime == null && post.expectedPublishingDatetime == null) {
          return 'draft';
      }
      else if(post.SocialPlatforms.length==0 && this.user?.isAdmin){
      // console.info("⚠️",post.id)
        return 'unattached'
      }
      else if (new Date(post.expectedPublishingDatetime) > new Date() ) {
        // console.info("✨",post.id)
        return 'planned';
      }
      else if ( this.hasPageswithNullExternalId(post) && post.status==null) {
        // console.info("❌",post.id)
        return 'failed';
      }
      else if(new Date(post.publishingDatetime) < new Date()) {
        // console.info("✅",post.id)
        return 'post';
      }
    }
  return ''
  }


  hasPageswithNullExternalId(post:any):boolean{
    return post.SocialPlatforms.every((platform:any) => platform.externalId === null )
  }
}
